{
  "name": "@ns/public-ledger-auto-payments-charge-failed",
  "version": "1.3.0",
  "description": "An automatic payment on the company's saved card failed (#25 phase 4). Claimable by the company's public ledger signatories; one per purchase (PURCHASE_ID). FAILURE says how: DECLINED or EXPIRED (cardHealth FAILED), or AUTH_REQUIRED, when the bank wants the card's owner (CARD_OWNER_ID) to confirm the same payment on-session: the job is then given straight to them (not claimable), and when they are no longer a signatory it is raised as a DECLINED card for the team. REOPENED is \"true\" on a card raised again after a change of card wasn't made. Every outcome is the server's: retry (public-ledger/autopay/card-action retry: a new attempt, with a new key), confirmed (the card's owner confirmed it there, action confirm then confirmed), paid (the payment went through another way, closed by autopay/charge), change-card (#25 phase 6: the holder entered a new card on this card, public-ledger/autopay/change-intent then confirm-change-card, which holds it under this workflow and completes the job). Completing it change-card has its workflow schedule one account-signed public ledger record (a transfer of 1 tinybar from the company's public ledger account to its operating account) whose memo names who changed the card, with no card details; the account signatories sign it, and the held card becomes the automatic payments card once it has run on the public ledger. When the change isn't made, a new card is raised for the same payment.",
  "inputs": {},
  "outcomes": {
    "retry": {
      "serverOnly": true
    },
    "confirmed": {
      "serverOnly": true
    },
    "paid": {
      "serverOnly": true
    },
    "change-card": {
      "serverOnly": true
    },
    "stopped": {
      "serverOnly": true
    }
  }
}
